<script setup lang="ts">
import { explainMonsterAffix } from '@/core/monster/affix'
import { useUserStore } from '@/stores/modules/user'
import type { NestMonsterType, PersonMonsterType } from '@/types/monster'
import { socketEmitAsync } from '@/utils/web-socket'
import { dayjs, ElMessage } from 'element-plus'
import { ref } from 'vue'
import { QuestionFilled } from '@element-plus/icons-vue'
import RuneTempleRank from './RuneTempleRank.vue'
import { Warning } from '@element-plus/icons-vue'

const userStore = useUserStore()

defineProps<{ monster?: NestMonsterType }>()
const emits = defineEmits(['start'])

async function handleStartRuneTower() {
  const curTime = dayjs()
  const week = curTime.day()
  if (week === 6) {
    const hour = curTime.hour()
    if (hour === 23) {
      const min = curTime.minute()
      if (min >= 55) return ElMessage.warning('符石神殿结算中，无法进入挑战')
    }
  }
  if (userStore.runeList.length > userStore.getRuneCapacity) return ElMessage.warning('符石背包已满，无法进行战斗')

  await socketEmitAsync<PersonMonsterType>({ type: 'startRuneTemple' })
  emits('start')
}
const rankShow = ref(false)
</script>

<template>
  <div class="border-wrap rune-tower">
    <h4 class="awaken">
      符石神殿
      <div class="help-info" style="margin-left: 5px">
        <el-popover placement="top" width="100%" trigger="click">
          <template #reference>
            <el-icon size="20"><QuestionFilled /></el-icon>
          </template>
          <div class="affix">
            <h4>符石神殿说明</h4>
            <p>1. 符石神殿<span class="info">每周日0点刷新</span>，每周都将有一只史诗级生物登场，同时怪物属性随机。</p>
            <p>
              2. 您需要在<span class="info">5分钟</span>的时间内通过挑战，战斗时支持<span class="info">切换装备即刻生效</span
              >，在合适的时机切换装备是通关的关键。
            </p>
            <p>3. 作为高难副本，建议您通过<span class="awaken">符石尖塔</span>获得足够强力的符石后再参与挑战。</p>
            <p>4. 挑战不限次数，当战斗失败时，<span class="grow">不会消耗</span>奖励次数。</p>
            <p>5. 通过奖励：1 <span class="legend">传说</span>符石，10 <span class="awaken">符石碎星</span>。</p>
          </div>
        </el-popover>
      </div>
    </h4>
    <p style="display: flex; align-items: center; color: red">
      <el-icon style="margin-right: 5px"><Warning /></el-icon>
      <span>终极副本，难度极高</span>
    </p>
    <p>
      <span>剩余奖励次数：{{ userStore.runeTempleTimes }}</span>
    </p>
    <p>
      本周怪物：
      <el-popover placement="bottom" :width="300" trigger="click" popper-class="monster-detail" :teleported="false" :disabled="!monster">
        <template #reference>
          <el-button size="small" type="danger" plain>
            <span v-show="monster">{{ monster?.name }}</span>
            <span v-show="!monster">暂无战斗</span>
          </el-button>
        </template>
        <div class="monster-detail">
          <h3 style="margin: 5px 0">{{ monster?.name }}</h3>
          <p>血量：{{ monster?.hp }}</p>
          <p>防御：{{ monster?.def }}</p>
          <p>闪避率：{{ monster?.evs }}%</p>
          <p>抗爆率：{{ monster?.crtdef }}%</p>
          <template v-if="monster?.special?.length">
            <p>特性：</p>
            <p v-for="item of explainMonsterAffix(monster.special)" v-html="item"></p>
          </template>
        </div>
      </el-popover>
    </p>
    <div style="margin: 10px 0">
      <el-button type="success" plain @click="handleStartRuneTower()" :disabled="userStore.runeTowerLevel < 5">
        {{ userStore.runeTowerLevel < 5 ? '每周通过符石尖塔 5层后解锁' : '开始战斗' }}
      </el-button>
      <!-- <el-button type="primary" plain @click="ElMessage.warning('功能开发中')" v-show="userStore.runeTowerLevel > 5">组队战斗</el-button> -->
      <el-button type="primary" plain @click="rankShow = true">排行</el-button>
    </div>
  </div>

  <el-dialog v-model="rankShow" width="100%" style="max-width: 500px">
    <RuneTempleRank />
    <template #footer>
      <p style="text-align: center">
        <el-button plain @click="rankShow = false" size="small">关闭</el-button>
      </p>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>
.rune-tower {
  flex-flow: column;
}
</style>
